module.exports = __webpack_public_path__ + "static/media/archive.b03cfd3a.svg";